var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "87.589%",
    cy: "-12.959%",
    fx: "87.589%",
    fy: "-12.959%",
    r: "128.455%",
    gradientTransform: "matrix(.81242 0 0 1 .164 0)",
    id: "firefox_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD4F",
    offset: "12.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC31",
    offset: "18.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D17",
    offset: "24.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF563B",
    offset: "40.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3750",
    offset: "46.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5156C",
    offset: "71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0878",
    offset: "78.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50080",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.455%",
    cy: "39.557%",
    fx: "49.455%",
    fy: "39.557%",
    r: "128.455%",
    gradientTransform: "matrix(.81242 0 0 1 .093 0)",
    id: "firefox_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960E18",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11927",
    stopOpacity: 0.74,
    offset: "35.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB293D",
    stopOpacity: 0.343,
    offset: "43.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5334B",
    stopOpacity: 0.094,
    offset: "49.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3750",
    stopOpacity: 0,
    offset: "53%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "56.997%",
    cy: "-29.965%",
    fx: "56.997%",
    fy: "-29.965%",
    r: "315.038%",
    gradientTransform: "matrix(1 0 0 .58872 0 -.123)",
    id: "firefox_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "13.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC3E",
    offset: "25.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D12",
    offset: "50.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "52.6%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "23.219%",
    cy: "110.079%",
    fx: "23.219%",
    fy: "110.079%",
    r: "111.769%",
    gradientTransform: "matrix(1 0 0 .91264 0 .096)",
    id: "firefox_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EE6",
    offset: "35.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C79F0",
    offset: "47.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059FF",
    offset: "66.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C139E6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "62.011%",
    cy: "36.562%",
    fx: "62.011%",
    fy: "36.562%",
    r: "59.259%",
    gradientTransform: "scale(1 .91264) rotate(-13.592 .767 .383)",
    id: "firefox_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059FF",
    stopOpacity: 0,
    offset: "20.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C4FF3",
    stopOpacity: 0.064,
    offset: "27.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7716A8",
    stopOpacity: 0.45,
    offset: "74.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E008B",
    stopOpacity: 0.6,
    offset: "97.5%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "221.811%",
    cy: "-103.337%",
    fx: "221.811%",
    fy: "-103.337%",
    r: "293.178%",
    gradientTransform: "matrix(1 0 0 .99368 0 -.007)",
    id: "firefox_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB27",
    offset: "12.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC82A",
    offset: "29.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA930",
    offset: "50.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E37",
    offset: "73.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7139",
    offset: "79.2%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "81.111%",
    cy: "-40.887%",
    fx: "81.111%",
    fy: "-40.887%",
    r: "193.807%",
    gradientTransform: "matrix(.83914 0 0 1 .13 0)",
    id: "firefox_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "11.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "45.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5634",
    offset: "62.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3647",
    offset: "71.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31587",
    offset: "90.4%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "11.59%",
    cy: "-10.313%",
    fx: "11.59%",
    fy: "-10.313%",
    r: "348.394%",
    gradientTransform: "matrix(.10494 .47127 -.99448 .04973 .001 -.153)",
    id: "firefox_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE847",
    offset: "6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC830",
    offset: "16.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B16",
    offset: "35.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF672A",
    offset: "45.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3647",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31587",
    offset: "73.7%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "19.461%",
    cy: "-42.624%",
    fx: "19.461%",
    fy: "-42.624%",
    r: "238.525%",
    gradientTransform: "matrix(.98168 0 0 1 .004 0)",
    id: "firefox_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "13.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5634",
    offset: "59.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3647",
    offset: "65.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31587",
    offset: "90.4%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "159.865%",
    cy: "-44.6%",
    fx: "159.865%",
    fy: "-44.6%",
    r: "312.954%",
    gradientTransform: "matrix(.8949 0 0 1 .168 0)",
    id: "firefox_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "9.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE141",
    offset: "23.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF1E",
    offset: "50.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "62.6%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.8%",
    y1: "15.5%",
    x2: "6.6%",
    y2: "93.1%",
    id: "firefox_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "4.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE847",
    offset: "11.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC830",
    offset: "22.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "36.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B16",
    offset: "40.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF672A",
    offset: "46.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3647",
    offset: "53.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31587",
    offset: "70.5%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "88.8%",
    y1: "15.1%",
    x2: "18%",
    y2: "83.5%",
    id: "firefox_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    stopOpacity: 0.8,
    offset: "16.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    stopOpacity: 0.634,
    offset: "26.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    stopOpacity: 0.217,
    offset: "48.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    stopOpacity: 0,
    offset: "60%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.857 167.835c-10.63-25.385-31.888-52.709-48.645-61.275a251.79 251.79 0 0124.573 73.468v.437c-27.324-68.34-73.78-95.85-111.733-155.875-2-3.002-3.877-6.065-5.752-9.254-1.063-1.876-1.876-3.502-2.689-5.002a44.08 44.08 0 01-3.626-9.629.625.625 0 00-.5-.625.875.875 0 00-.626 0v.125c0 .125-.187 0-.187 0V.08c-60.775 35.64-81.471 101.666-83.347 134.617a121.3 121.3 0 00-66.714 25.76 72.53 72.53 0 00-6.253-4.752 112.358 112.358 0 01-.625-59.399 179.448 179.448 0 00-58.399 45.144c-9.691-12.13-9.004-52.272-8.44-60.65a43.33 43.33 0 00-8.13 4.252 176.51 176.51 0 00-23.759 20.32 211.586 211.586 0 00-22.509 27.199 204.646 204.646 0 00-32.513 73.405l-.438 1.688c-.438 2.063-2.126 12.755-2.376 15.006v.625a230.969 230.969 0 00-3.876 33.389v1.25c.202 125.716 96.5 230.404 221.762 241.082 125.261 10.679 237.89-76.198 259.37-200.065.438-3.126.75-6.252 1.126-9.379a249.226 249.226 0 00-15.631-121.737h-.063zm-279.3 189.64c1.125.625 2.188 1.25 3.313 1.688l.188.125a96.082 96.082 0 01-3.44-1.876l-.062.063z",
    fill: "url(#firefox_svg__a)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.857 167.835c-10.63-25.385-31.888-52.709-48.645-61.275a251.79 251.79 0 0124.573 73.468v.5a219.464 219.464 0 01-7.503 163.566c-27.761 59.587-95.039 120.675-200.27 117.673-113.67-3.126-213.836-87.535-232.594-198.08-3.376-17.507 0-26.26 1.751-40.454A180.573 180.573 0 00.293 256.62v1.251c.202 125.715 96.5 230.403 221.762 241.082 125.261 10.678 237.89-76.198 259.37-200.065.438-3.127.75-6.253 1.126-9.38a249.226 249.226 0 00-15.631-121.736l-.063.062z",
    fill: "url(#firefox_svg__b)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.857 167.835c-10.63-25.385-31.888-52.709-48.645-61.275a251.79 251.79 0 0124.573 73.468v.5a219.464 219.464 0 01-7.503 163.566c-27.761 59.587-95.039 120.675-200.27 117.673-113.67-3.126-213.836-87.535-232.594-198.08-3.376-17.507 0-26.26 1.751-40.454A180.573 180.573 0 00.293 256.62v1.251c.202 125.715 96.5 230.403 221.762 241.082 125.261 10.678 237.89-76.198 259.37-200.065.438-3.127.75-6.253 1.126-9.38a249.226 249.226 0 00-15.631-121.736l-.063.062z",
    fill: "url(#firefox_svg__c)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.06 196.284c.625.376 1 .75 1.5 1.126a131.929 131.929 0 00-22.51-29.387C252.77 92.743 308.356 4.707 317.735.267V.08c-60.775 35.64-81.47 101.666-83.346 134.617 2.813-.188 5.627-.375 8.503-.375 43.94.063 84.468 23.693 106.168 61.9v.062z",
    fill: "url(#firefox_svg__d)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.079 211.416c-.438 5.94-21.697 26.76-29.2 26.76-68.903 0-80.032 41.642-80.032 41.642 3.001 35.14 27.511 64.026 57.023 79.408l4.127 1.875a171.406 171.406 0 007.128 2.94 107.731 107.731 0 0031.512 6.127c120.8 5.627 144.184-144.434 57.024-188.014a83.659 83.659 0 0158.398 14.255c-21.7-38.207-62.228-61.836-106.168-61.9-2.876 0-5.627.125-8.503.313a121.3 121.3 0 00-66.715 25.76c3.752 3.127 7.878 7.253 16.694 15.944 16.445 16.257 58.587 32.951 58.774 35.015l-.062-.125z",
    fill: "url(#firefox_svg__e)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.079 211.416c-.438 5.94-21.697 26.76-29.2 26.76-68.903 0-80.032 41.642-80.032 41.642 3.001 35.14 27.511 64.026 57.023 79.408l4.127 1.875a171.406 171.406 0 007.128 2.94 107.731 107.731 0 0031.512 6.127c120.8 5.627 144.184-144.434 57.024-188.014a83.659 83.659 0 0158.398 14.255c-21.7-38.207-62.228-61.836-106.168-61.9-2.876 0-5.627.125-8.503.313a121.3 121.3 0 00-66.715 25.76c3.752 3.127 7.878 7.253 16.694 15.944 16.445 16.257 58.587 32.951 58.774 35.015l-.062-.125z",
    fill: "url(#firefox_svg__f)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.418 152.392c1.876 1.25 3.564 2.313 5.003 3.313a112.358 112.358 0 01-.626-59.399 179.448 179.448 0 00-58.398 45.144c1.25 0 36.264-.626 54.021 10.88v.062z",
    fill: "url(#firefox_svg__g)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48 263.687c18.759 110.482 118.8 194.892 232.595 198.08 105.23 3.002 172.446-58.148 200.207-117.673a219.464 219.464 0 007.503-163.566v-.5l.125.437c8.503 56.148-20.008 110.483-64.651 147.248l-.188.312c-86.91 70.842-170.069 42.768-186.95 31.263a40.455 40.455 0 01-3.565-1.75c-50.645-24.198-71.654-70.404-67.152-110.045-24.58.37-47.074-13.768-57.398-36.077a91.412 91.412 0 0189.098-3.564 120.674 120.674 0 0090.912 3.564c-.125-2.001-42.267-18.758-58.774-35.015-8.753-8.628-12.88-12.755-16.631-15.881a72.53 72.53 0 00-6.253-4.752c-1.438-1-3.001-2.063-5.002-3.314-17.632-11.505-52.771-10.88-53.96-10.88h-.125c-9.566-12.13-8.94-52.27-8.378-60.649a43.33 43.33 0 00-8.128 4.252 176.51 176.51 0 00-23.76 20.383 211.586 211.586 0 00-22.697 27.136 204.646 204.646 0 00-32.513 73.405c-.125.5-8.753 38.14-4.502 57.648l.188-.062z",
    fill: "url(#firefox_svg__h)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.113 168.023a131.929 131.929 0 0122.51 29.387c1.25 1.063 2.5 2.063 3.626 3.001 55.022 50.646 26.26 122.237 24.072 127.364 44.58-36.765 73.155-91.1 64.589-147.247-27.511-68.34-73.905-95.851-111.92-155.876a401.146 401.146 0 01-5.628-9.254c-1.063-1.875-1.876-3.501-2.688-5.002a44.08 44.08 0 01-3.69-9.691.625.625 0 00-.5-.625.875.875 0 00-.625 0v.125c0 .125-.187 0-.187 0-9.38 4.502-65.027 92.537 10.379 167.818h.062z",
    fill: "url(#firefox_svg__i)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.186 200.411c-1.063-1-2.313-2-3.626-3.001l-1.5-1.126a83.659 83.659 0 00-58.462-14.193c87.16 43.643 63.776 193.829-57.023 188.077a107.731 107.731 0 01-31.45-6.065 84.945 84.945 0 01-7.128-2.877c-1.376-.625-2.689-1.25-4.064-1.875h.187c16.882 11.504 100.04 39.64 187.076-31.263l.125-.25c2.189-5.002 30.95-76.719-24.01-127.302l-.125-.125z",
    fill: "url(#firefox_svg__j)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.784 279.818s11.255-41.642 80.033-41.642c7.503 0 28.762-20.82 29.262-26.885a120.674 120.674 0 01-91.037-3.502 91.412 91.412 0 00-89.099 3.564c10.362 22.327 32.913 36.446 57.523 36.015-4.564 39.64 16.382 85.847 67.09 110.044 1.126.626 2.189 1.126 3.314 1.689-29.575-15.32-54.022-44.206-57.086-79.408v.125z",
    fill: "url(#firefox_svg__k)",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.857 167.835c-10.63-25.385-31.888-52.709-48.645-61.275a251.79 251.79 0 0124.573 73.468v.437c-27.324-68.34-73.78-95.85-111.733-155.875-2-3.002-3.877-6.065-5.752-9.254-1.063-1.876-1.876-3.502-2.689-5.002a44.08 44.08 0 01-3.626-9.629.625.625 0 00-.5-.625.875.875 0 00-.626 0v.125c0 .125-.187 0-.187 0V.08c-60.775 35.64-81.471 101.666-83.347 134.617 2.814-.188 5.627-.375 8.504-.375 43.94.063 84.468 23.693 106.168 61.9a83.659 83.659 0 00-58.399-14.13c87.16 43.642 63.776 193.828-57.023 188.076a107.731 107.731 0 01-31.513-6.065 84.945 84.945 0 01-7.128-2.877l-4.127-1.875h.188a89.617 89.617 0 01-3.439-1.751c1.126.625 2.189 1.25 3.314 1.688-29.575-15.319-54.022-44.205-57.086-79.407 0 0 11.255-41.58 80.033-41.58 7.503 0 28.762-20.82 29.262-26.885-.125-1.876-42.267-18.758-58.774-34.89-8.754-8.753-12.943-12.817-16.632-15.944a72.53 72.53 0 00-6.252-4.752 112.358 112.358 0 01-.626-59.399 179.448 179.448 0 00-58.398 45.144c-9.692-12.13-9.004-52.272-8.441-60.65a43.33 43.33 0 00-8.129 4.252 176.51 176.51 0 00-23.76 20.32 211.586 211.586 0 00-22.508 27.2A204.646 204.646 0 007.045 206.1l-.5 1.563c-.438 2.063-2.5 12.943-2.814 15.256a281.99 281.99 0 00-3.563 33.764v1.25C.37 383.65 96.668 488.338 221.93 499.016c125.261 10.679 237.89-76.198 259.37-200.065.438-3.126.75-6.252 1.126-9.379a249.226 249.226 0 00-15.631-121.737h.062z",
    fill: "url(#firefox_svg__l)",
    transform: "translate(8)"
  }))));
}
export default SvgFirefox;